<script>
export default {
    name: 'AlertExtendsQuantity',
    props: ['isOpen', 'itemsExedsQuantity'],
    data(){
        return {
            dialog: false
        }
    },

    watch: {
      isOpen(value) {
        this.dialog = value;
      }
    },
}
</script>

<template>
    <v-dialog v-model="dialog">
        <v-card>
            <v-app-bar  flat color="transparent">
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="title">
                    Atenção
                </v-toolbar-title>
            </v-app-bar>

            <v-container> </v-container>

            <v-container>
                <v-alert
                    type="warning"
                    class="mt-4"
                >
                    Atenção! Alguns itens da nota fiscal excedem a quantidade do pedido de compra vinculado. Alguns itens precisam ser revisados. <br />
                    Os itens do tipo "PC" e de "Caldeiraria" não podem ser vinculados.
                </v-alert>

                <v-simple-table>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Item</th>
                            <th>Quantidade do Item</th>
                            <th>Quantidade Compra</th>
                            <th>Unidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in itemsExedsQuantity" :key="index">
                            <td>{{ item.osItem.itemCodigo }}</td>
                            <td>{{ item.osItem.descricao }}</td>
                            <td>{{ item.quantidade }}</td>
                            <td>{{ item.osItem.quantidadeCompra }}</td>
                            <td>{{ item.osItem.unidadeSigla }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>

            <v-card-actions>
                <v-btn
                    color="primary"
                    @click="$emit('close')"
                >
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>